import Select from "ol/interaction/Select";
import { click, pointerMove } from "ol/events/condition";
import { getHDMapStyleClick, getHDMapStyleHover } from "../style/hdmap";

export function getHDMapInteractions(layer, control) {
  const clickSelect = new Select({
    layers: [layer],
    condition: click,
    style: function (feature, resolution) {
      return getHDMapStyleClick(feature, resolution);
    },
  });
  clickSelect.on("select", function (e) {
    if (e.target.getFeatures().getLength() > 0) {
      control.set(
        "selectedFeatures",
        Array.from(e.target.getFeatures().getArray()),
      ); // create new array so that the event gets triggered
    } else {
      control.set("selectedFeatures", undefined);
    }
  });
  return [
    clickSelect,
    new Select({
      layers: [layer],
      condition: pointerMove,
      style: function (feature, resolution) {
        return getHDMapStyleHover(feature, resolution);
      },
    }),
  ];
}
